"use client";

import React from "react";

/**
 * QuarkleLoader — the three-orb loader used across the app.
 *
 * Each orb (big banded → striped → small) pops in on a staggered
 * cycle, cloning the animation from public/quarkle-loader.html.
 * Colour follows `currentColor`, so the loader picks up the
 * surrounding theme automatically (ink on Paper, paper on Midnight).
 *
 * NOTE: do not use inside the chat thinking indicator — that one
 * has its own dedicated three-planet animation.
 */
export default function QuarkleLoader({
  size = 96,
  color,
  className = "",
  style = {},
  "aria-label": ariaLabel = "Loading",
}) {
  return (
    <div
      role="status"
      aria-label={ariaLabel}
      className={`qk-three-orb-loader ${className}`}
      style={{
        width: size,
        height: size,
        color: color || "var(--qk-ink)",
        display: "inline-block",
        ...style,
      }}
    >
      <svg
        viewBox="0 0 84 84"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        style={{ display: "block", width: "100%", height: "100%", overflow: "visible" }}
      >
        <g className="qk-orb qk-orb--banded">
          <circle cx="46" cy="58" r="22" strokeWidth="3" />
          <path d="M27 52 Q37 47 47 52 T67 54" strokeWidth="2.5" />
          <path d="M25 62 Q37 57 47 62 T69 62" strokeWidth="2.5" />
          <path d="M28 70 Q38 66 48 70" strokeWidth="2.5" />
        </g>
        <g className="qk-orb qk-orb--striped">
          <circle cx="20" cy="24" r="14" strokeWidth="3" />
          <line x1="10" y1="22" x2="30" y2="22" strokeWidth="2.5" />
          <line x1="8" y1="27" x2="24" y2="27" strokeWidth="2.5" />
        </g>
        <g className="qk-orb qk-orb--small">
          <circle cx="62" cy="18" r="10" strokeWidth="3" />
        </g>
      </svg>
    </div>
  );
}
